import { defineComponent as _defineComponent } from 'vue'
import WistiaVideo from '~/components/WistiaVideo.vue';
import TLinkButton from '~/components/atoms/t-link-button.vue';

interface SectionVideoProps {
  title: string;
  description: string;
  cta: {
    title: string;
    url?: string;
    signup?: boolean;
  };
  wistiaId: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SectionVideo',
  props: {
    title: null,
    description: null,
    cta: null,
    wistiaId: null
  },
  setup(__props: any) {



return { __sfc: true,WistiaVideo, TLinkButton }
}

})